module.exports = __webpack_public_path__ + "img/firstEdition2.47d09a9f.jpg";